import { render, staticRenderFns } from "./EmailPreviewComponent.vue?vue&type=template&id=0f5c7a8f&scoped=true"
import script from "./EmailPreviewComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./EmailPreviewComponent.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./EmailPreviewComponent.vue?vue&type=style&index=0&id=0f5c7a8f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f5c7a8f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f5c7a8f')) {
      api.createRecord('0f5c7a8f', component.options)
    } else {
      api.reload('0f5c7a8f', component.options)
    }
    module.hot.accept("./EmailPreviewComponent.vue?vue&type=template&id=0f5c7a8f&scoped=true", function () {
      api.rerender('0f5c7a8f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FileManager/Preview/components/EmailPreviewComponent/EmailPreviewComponent.vue"
export default component.exports